import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss']
})
export class EmptyStateComponent {
  @Input() icon: string = '';
  @Input() imageSrc: string = '';
  @Input() title: string = 'No Data';
  @Input() message: string = 'No data available at this time.';
  @Input() isDashboardWidget: boolean = false;
}
